/**
 * sign.js
 * @authors Tommy (tao@winjoyit.com)
 * @date    2024-02-28 16:17:49
 * @version $Id$
 */

import { sha256 } from 'js-sha256'

/**
 * 生成签名：将参数对象深度排序并 JSON.stringify 后参与签名
 * @param {Object|Array} params - 请求参数（支持对象、数组、嵌套结构）
 * @param {Number} timestamp - 时间戳
 * @param {String} nonstr - 随机字符串
 * @returns {String} - SHA256 签名
 */
export function sign(params, timestamp, nonstr) {
    // 1. 深度排序并标准化参数（过滤 sign、undefined、function）
    const normalizedParams = normalizeParams(params)

    // 2. 生成签名原文
    const signString = normalizedParams + timestamp + nonstr

    // 3. 生成 SHA256 签名
    return sha256(signString)
}

/**
 * 深度排序并标准化参数对象/数组
 * @param {any} obj - 参数对象/数组
 * @returns {String} - JSON 字符串
 */
function normalizeParams(obj) {
    function deepSort(data) {
        if (data === null || typeof data !== 'object' || data instanceof Date) {
            return data
        }

        // 处理数组
        if (Array.isArray(data)) {
            return data.map(deepSort)
        }

        // 处理对象
        const sorted = {}
        const keys = Object.keys(data).sort()
        for (const key of keys) {
            const value = data[key]

            // 过滤掉 undefined 和 function
            if (value === undefined || typeof value === 'function') continue

            // 处理 null 转换为空字符串
            sorted[key] = value === null ? '' : deepSort(value)
        }
        return sorted
    }

    // 生成标准化 JSON 字符串（过滤 undefined 和 function）
    return JSON.stringify(deepSort(obj), (key, value) => {
        if (typeof value === 'function' || value === undefined) return undefined
        return value === null ? '' : value
    })
}

/**
 * 生成随机 nonce 字符串
 */
export function nonce(len = 32) {
    const $chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let maxPos = $chars.length;
    let nonce = '';
    for (let i = 0; i < len; i++) {
        nonce += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return nonce;
}